import { t } from "@ebay/i18n-ebay";
import { getPropsForClickTracking, composeAttrsForClickTracking } from "../../utils/tracking";
import { ENTER_FULLSCREEN_CLICK_ID, EXIT_FULLSCREEN_CLICK_ID } from "../map-location-tourtip/const";

$ const { isMapExpanded } = input;
$ const trackingId = isMapExpanded ? EXIT_FULLSCREEN_CLICK_ID : ENTER_FULLSCREEN_CLICK_ID;

<div class="map-expand map-component-with-tooltip">
  <span class="map-component-tooltip">
    <fe-textual-display model=t("mapview/map", isMapExpanded ? "closeFullMapTooltipLabel" : "openFullMapTooltipLabel")/>
  </span>
  <ebay-icon-button
    data-testid="map-expand-button"
    on-click("onCtaClick")
    ...getPropsForClickTracking([{ ...composeAttrsForClickTracking(trackingId, "button") }])
  >
    <if(isMapExpanded)>
      <ebay-close-16-icon/>
    </if>
    <else>
      <ebay-arrows-expand-16-icon/>
    </else>
  </ebay-icon-button>
</div>
